// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"b1fb8af5","34":"9654d385","122":"3a7d314c","532":"5b067833","603":"a1d72c29","920":"05bd156f"}[chunkId] + ".chunk.css";
};